import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Typography } from '@mui/material';
import { useApp } from '../../Contexts/AppProvider';

export default function Loading() {
  const {loading} = useApp();
  
  return loading ? (
    <div>
      <Backdrop
        sx={{ flexDirection: 'column', color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <CircularProgress color="inherit" />
        <br />
        <Typography>{loading}</Typography>
      </Backdrop>
    </div>
  ) : <></>;
}